require("./components/bootstrap");
import mixin from "./components/mixin.js";
import member from "./components/member.js";

var memberForgot = new Vue({
  el: "#app",
  mixins: [mixin, member],
  data: {
    forgotData: {
      mobilePhone: mobilePhone,
    },
  },
  watch: {
    "forgotData.mobilePhone": function (val) {
      this.forgotData.mobilePhone = this.restrictMobile(val)
    },
  },
  computed: {
    showMobile: function () {
      return this.validateMobile(this.forgotData.mobilePhone)
    }
  },
  methods: {
    forgot: async function () {
      if (this.showMobile) {
        let url = eatizen ? "/member/eatizen/password/forgot" : "/member/password/forgot"
        const result = await this.memberApi(url, this.forgotData)
        if (result.status) {
          showAlert("", submitSuccess, false, () => {
            location.reload()
          })
        } else {
          this.showAlert("", result.message)
        }
      }
    }
  },
});
